import { render, staticRenderFns } from "./purchase-detail.vue?vue&type=template&id=0d618d96"
import script from "./purchase-detail.vue?vue&type=script&lang=js"
export * from "./purchase-detail.vue?vue&type=script&lang=js"
import style0 from "./purchase-detail.vue?vue&type=style&index=0&id=0d618d96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports